import { FunctionComponent } from "react";
import { faSparkles } from "@fortawesome/pro-regular-svg-icons";

import { Icon } from "@/components";
import { classNames } from "@/utils/classNames";

import { FieldMappingSourceType } from "../../schema/hubspot";

interface SourceTypePillsProps {
	value: FieldMappingSourceType;
	onChange: (next: FieldMappingSourceType) => void;
	labels: {
		fromRecord: string;
		constant: string;
		ai?: string;
	};
	testIdPrefix: string;
}

export const SourceTypePills: FunctionComponent<SourceTypePillsProps> = ({
	value,
	onChange,
	labels,
	testIdPrefix,
}) => {
	const isField = value === FieldMappingSourceType.FIELD;
	const isConstant = value === FieldMappingSourceType.CONSTANT;
	const isAi = value === FieldMappingSourceType.AI;

	return (
		<div className="inline-flex rounded-md border border-border-light overflow-hidden text-xs w-fit bg-white">
			<button
				className={classNames(
					"px-3 py-1.5 transition-colors cursor-pointer",
					isField
						? "bg-brand-light text-white font-semibold"
						: "bg-brand-white text-text-meta hover:text-text"
				)}
				data-testid={`${testIdPrefix}-source-type-field`}
				type="button"
				onClick={() => onChange(FieldMappingSourceType.FIELD)}
			>
				{labels.fromRecord}
			</button>
			<button
				className={classNames(
					"px-3 py-1.5 transition-colors cursor-pointer",
					isConstant
						? "bg-brand-light text-white font-semibold"
						: "bg-brand-white text-text-meta hover:text-text"
				)}
				data-testid={`${testIdPrefix}-source-type-constant`}
				type="button"
				onClick={() => onChange(FieldMappingSourceType.CONSTANT)}
			>
				{labels.constant}
			</button>
			{labels.ai && (
				<button
					className={classNames(
						"px-3 py-1.5 transition-colors cursor-pointer inline-flex items-center gap-1.5",
						isAi
							? "bg-purple-800 text-white font-semibold"
							: "bg-brand-white text-text-meta hover:text-text"
					)}
					data-testid={`${testIdPrefix}-source-type-ai`}
					type="button"
					onClick={() => onChange(FieldMappingSourceType.AI)}
				>
					<Icon className="w-3 h-3" icon={faSparkles} />
					{labels.ai}
				</button>
			)}
		</div>
	);
};
